// import {
//     Container,
//     Typography,
//     Stack,
//     Grid,
//     TextField,
//     Autocomplete,
//     CardContent,
//     Card,
//     FormControl,
//     MenuItem,
//     InputLabel,
//     OutlinedInput,
//     Chip,
//     Box, Select,
//     InputAdornment,
//     Button,
//     FormControlLabel,
//     Checkbox,
//     TableHead,
//     TableRow,
//     TableCell,
//     Table,
//     TableContainer,
//     TableBody,
//     Alert,
//     Divider,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     ListSubheader
// } from '@mui/material';
// import Page from 'src/components/Page';
// import clientApi from 'src/api/clients';
// import { useEffect, useState } from 'react';
// import Scrollbar from 'src/components/Scrollbar';
// import { addCredits, getCredits, updateCredits } from 'src/api/credits';
// import CloseIcon from '@mui/icons-material/Close';
// import { getClientProperties } from 'src/api/ShiftMaster';


// export default function Credits() {
//     const [client, setClient] = useState([]);
//     const [selectedClients, setSelectedClients] = useState([]);
//     const [inputValue, setInputValue] = useState([]);
//     const [status, setStatusBase] = useState(false);
//     const [message, setMessage] = useState('');
//     const [selectedYears, setSelectedYears] = useState('');
//     const [selectedMonths, setSelectedMonths] = useState([]);
//     const [locations, setLocations] = useState([]);
//     const [selectedLocation, setSelectedLocation] = useState(null);
//     const [pricing, setPricing] = useState('');
//     const [clientError, setClientError] = useState('');
//     const [yearError, setYearError] = useState('');
//     const [monthsError, setMonthsError] = useState('');
//     const [locationError, setLocationError] = useState('');
//     const [pricingError, setPricingError] = useState('');
//     const [alertType, setAlertType] = useState('success');
//     const [creditsData, setCreditsData] = useState([]);
//     const [editDialogOpen, setEditDialogOpen] = useState(false);
//     const [editingRow, setEditingRow] = useState(null);
//     const [editPricing, setEditPricing] = useState('');
//     const [editPricingError, setEditPricingError] = useState('');
//     const [priceChangeMessage, setPriceChangeMessage] = useState('');

//     const normalizeDisplayName = (name) =>
//         String(name || '')
//             .trim()
//             .replace(/\s+/g, ' ')
//             .toLowerCase();

//     const buildUniqueClientOptions = (clients) => {
//         const grouped = new Map();

//         (clients || []).forEach((clientItem) => {
//             const key = normalizeDisplayName(clientItem?.displayname);
//             if (!key) return;

//             if (!grouped.has(key)) {
//                 grouped.set(key, []);
//             }

//             grouped.get(key).push(clientItem);
//         });

//         return Array.from(grouped.values()).map((groupItems) => {
//             if (groupItems.length === 1) {
//                 return groupItems[0];
//             }

//             const assignTargets = new Set(
//                 groupItems
//                     .map((item) => Number(item.AssignClient || 0))
//                     .filter((assignId) => assignId > 0)
//             );

//             const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
//             if (mappedMain) {
//                 return mappedMain;
//             }

//             const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
//             return rootEntry || groupItems[0];
//         });
//     };

//      const monthOptions = [
//         'January', 'February', 'March', 'April', 'May', 'June',
//         'July', 'August', 'September', 'October', 'November', 'December'
//     ];

//     const uniqueClientOptions = buildUniqueClientOptions(client);

//     const currentYear = new Date().getFullYear();
//     const yearOptions = [currentYear, currentYear + 1, currentYear + 2];


//     const filteredCreditsData = creditsData.filter((row) => {
//     const clientMatch =
//         selectedClients.length === 0 ||
//         selectedClients.some(
//             (c) =>
//                 c.displayname.trim().toLowerCase() ===
//                 row.clientName.trim().toLowerCase()
//         );

//     const yearMatch =
//     !selectedYears ||
//     row.year === Number(selectedYears);

//     const monthMatch =
//         selectedMonths.length === 0 ||
//         selectedMonths.some(
//             (month) =>
//                 monthOptions.findIndex((m) => m === month) + 1 === row.month
//         );

//     return clientMatch && yearMatch && monthMatch;
// });

   

//     useEffect(() => {
//         clientApi.getClients((response) => {
//             if (response.status === 200) {
//                 const usClients = response.data.filter(client => client.ClientType === "US" && client.EnvironmentType!==0);
//                 const sortedData = [...usClients].sort((a, b) =>
//                     a.displayname.trim().localeCompare(b.displayname.trim())
//                 )
//                 setClient(sortedData)
//             }
//         })
//     }, [])

//     const handleClientChange = (event) => {
//         const value = event.target.value;
//         const selected = value ? [value] : [];

//         setSelectedClients(selected);
//         if (selected.length > 0) {
//             fetchLocationsByClients(selected);
//         } else {
//             setLocations([]);
//             setSelectedLocation(null);
//         }
//         setClientError('');
//     };

//     const handleYearChange = (event) => {
//         setSelectedYears(event.target.value);
//         setYearError('');
//     };

//     const handleMonthChange = (event) => {
//         const value = event.target.value;

//         if (value.includes('select-all')) {
//             if (selectedMonths.length === monthOptions.length) {
//                 setSelectedMonths([]);
//             } else {
//                 setSelectedMonths([...monthOptions]);
//             }
//         } else {
//             setSelectedMonths(value.filter(v => v !== 'select-all'));
//         }
//         setMonthsError('');
//     };

//     const fetchLocationsByClients = (clients) => {
//         if (!clients || clients.length === 0) {
//             setLocations([]);
//             setSelectedLocation(null);
//             return;
//         }

//         const mainClientId = Number(clients?.[0]?.ID || clients?.[0]?.id || 0);
//         if (!mainClientId) {
//             setLocations([]);
//             setSelectedLocation(null);
//             return;
//         }

//         getClientProperties({ AssignClient: String(mainClientId) }, (response) => {
//             if (response.status === 200) {
//                 const uniqueLocations = Array.from(
//                     new Map(normalizeLocations(response.data).map((location) => [location.ID, location])).values()
//                 );
//                 setLocations(uniqueLocations);
//             } else {
//                 setLocations([]);
//             }
//             setSelectedLocation(null);
//         });
//     };

//     const normalizeLocations = (locationResponse) => {
//         const responseArray = Array.isArray(locationResponse)
//             ? locationResponse
//             : (locationResponse ? [locationResponse] : []);

//         return responseArray
//             .map((location) => ({
//                 ...location,
//                 ID: Number(location?.ID ?? location?.id ?? 0),
//                 Location: (location?.Location || location?.name || '').trim()
//             }))
//             .filter((location) => location.ID > 0);
//     };

//     const handleLocationChange = (_, value) => {
//         setSelectedLocation(value);
//         if (value) {
//             setLocationError('');
//         }
//     };

//     useEffect(() => {
//         const updatedInputValues = inputValue.filter(camera => selectedClients.includes(camera.clientid));
//         setInputValue([...updatedInputValues]);
//     }, [selectedClients.length]);

//     const processCreditsData = (apiData) => {
//         const rows = [];
//         let clientCounter = 1;

//         apiData.forEach(clientData => {
//             const clientName = Object.keys(clientData)[0];
//             const creditEntries = clientData[clientName];
//             const clientId = clientCounter++;
//             const clientLocation = (clientData.Location || '').trim();

//             creditEntries.forEach(entry => {
//                 entry.credit_details.forEach(detail => {
//                     rows.push({
//                         id: clientId,
//                         clientName: clientName,
//                         location: clientLocation,
//                         year: entry.year,
//                         month: detail.Month,
//                         credits: detail.Credits,
//                         ClientCreditsId: detail.ClientCreditsId
//                     });
//                 });
//             });
//         });

//         return rows;
//     };

//     const sortCreditsRows = (rows) => [...rows].sort((a, b) => {
//         if (a.clientName < b.clientName) return -1;
//         if (a.clientName > b.clientName) return 1;

//         if (a.year !== b.year) return a.year - b.year;

//         if (a.month !== b.month) return a.month - b.month;

//         if (a.credits !== b.credits) return a.credits - b.credits;

//         return (a.location || '').localeCompare(b.location || '');
//     });

//     useEffect(() => {
//         getCredits((response) => {
//             if (response.status === 200) {
//                 const resultData = response.data;
//                 let res = JSON.parse(JSON.stringify(resultData));
//                 const processedData = processCreditsData(res);
//                 const sortedData = sortCreditsRows(processedData);
//                 setCreditsData(processedData);
//             }
//         })
//     }, [])

//     const handleClear = () => {
//         setSelectedClients([]);
//         setSelectedYears('');
//         setSelectedMonths([]);
//         setLocations([]);
//         setSelectedLocation(null);
//         setPricing('');
//         setClientError('');
//         setYearError('');
//         setMonthsError('');
//         setLocationError('');
//         setPricingError('');
//     };

//     const handleAdd = () => {
//         setClientError('');
//         setYearError('');
//         setMonthsError('');
//         setLocationError('');
//         setPricingError('');

//         let hasError = false;

//         if (!selectedClients.length) {
//             setClientError('Please select at least one client');
//             hasError = true;
//         }

//        if (!selectedYears) {
//             setYearError('Please select at least one year');
//             hasError = true;
//         }

//         if (!selectedMonths.length) {
//             setMonthsError('Please select at least one month');
//             hasError = true;
//         }

//         if (locations.length > 0 && !selectedLocation) {
//             setLocationError('Please select a location');
//             hasError = true;
//         }

//         if (!pricing || parseFloat(pricing) <= 0) {
//             setPricingError('Please enter valid pricing');
//             hasError = true;
//         }

//         if (hasError) return;

//         // Check for existing credits for each selected client
//         const allExistingMonths = [];
//         selectedClients.forEach(clientItem => {
//             const clientId = clientItem.ID;
//             const clientName = clientItem.displayname;
//             const existingMonths = checkExistingCredits(
//                 clientId,
//                 selectedYears,
//                 selectedMonths,
//                 selectedLocation?.Location || ''
//             );

//             if (existingMonths.length > 0) {
//                 allExistingMonths.push({
//                     clientName,
//                     year: selectedYears,
//                     months: existingMonths
//                 });
//             }
//             // selectedYears.forEach(year => {
//             //     const existingMonths = checkExistingCredits(
//             //         clientId,
//             //         year,
//             //         selectedMonths,
//             //         selectedLocation?.Location || ''
//             //     );
                
//             //     if (existingMonths.length > 0) {
//             //         allExistingMonths.push({
//             //             clientName,
//             //             year,
//             //             months: existingMonths
//             //         });
//             //     }
//             // });
//         });

//         if (allExistingMonths.length > 0) {
//             const errorMessages = allExistingMonths.map(item => 
//                 `${item.clientName} (${item.year}) - ${item.months.join(', ')}`
//             );
//             setMessage(`Data already exists for:\n${errorMessages.join('\n')}. Please go to edit option to update it.`);
//             setAlertType('error');
//             setStatusBase(true);
//             return;
//         }

//         // Prepare data for each client and year combination
//         const monthsArray = selectedMonths.map(monthName => {
//             const monthIndex = monthOptions.findIndex(m => m === monthName);
//             return {
//                 Month: monthIndex + 1,
//                 Credits: parseFloat(pricing)
//             };
//         });

//         const selectedClientIds = selectedClients
//             .map((selectedClient) => String(selectedClient.ID || selectedClient.id || ''))
//             .filter((id) => id);
        
//         const selectedLocationId = String(selectedLocation?.ID || selectedLocation?.id || '');
//         const payloadIds = locations.length > 0 && selectedLocationId && Number(selectedLocationId) > 0
//             ? [selectedLocationId]
//             : selectedClientIds;

//         const requestData = {
//             ClientId: payloadIds.join(','),
//             Years: selectedYears.toString(),
//             months: monthsArray
//         };

//         addCredits(requestData, (response) => {
//             if (response.status === 200 || response.status === 201) {
//                 setMessage('Credits added successfully!');
//                 setAlertType('success');
//                 setStatusBase(true);
//                 handleClear();
//                 getCredits((response) => {
//                     if (response.status === 200) {
//                         const resultData = response.data;
//                         let res = JSON.parse(JSON.stringify(resultData));
//                         const processedData = processCreditsData(res);
//                         const sortedData = sortCreditsRows(processedData);
//                         setCreditsData(sortedData);
//                     }
//                 });
//             }
//             else {
//                 setMessage(`Data insertion failed`);
//                 setAlertType('error');
//                 setStatusBase(true);
//             }
//         })
//     };

//     useEffect(() => {
//         if (status && message) {
//             const timer = setTimeout(() => {
//                 setMessage('');
//                 setStatusBase(false);
//             }, 2000);

//             return () => clearTimeout(timer);
//         }
//     }, [status, message]);

//     const calculateRowSpan = (data) => {
//         const counts = {};

//         data.forEach(row => {
//             const key = row.clientName;
//             counts[key] = (counts[key] || 0) + 1;
//         });

//         return counts;
//     };

//     const rowSpanCounts = calculateRowSpan(filteredCreditsData);

//     const calculateLocationRowSpan = (data) => {
//         const counts = {};

//         data.forEach(row => {
//             const key = `${row.clientName}_${row.location || ''}`;
//             counts[key] = (counts[key] || 0) + 1;
//         });

//         return counts;
//     };

//     const locationRowSpanCounts = calculateLocationRowSpan(filteredCreditsData);

//     const calculateYearRowSpan = (data) => {
//         const map = {};

//         data.forEach(row => {
//             const key = `${row.clientName}_${row.location || ''}_${row.year}`;
//             map[key] = (map[key] || 0) + 1;
//         });

//         return map;
//     };

//     const yearRowSpanCounts = calculateYearRowSpan(filteredCreditsData);

//     const calculateCreditRowSpans = (data) => {
//         const spans = {};
//         let startIndex = 0;

//         while (startIndex < data.length) {
//             const currentRow = data[startIndex];
//             const currentKey = `${currentRow.clientName}_${currentRow.year}_${currentRow.month}_${currentRow.credits}`;
//             let span = 1;

//             while (startIndex + span < data.length) {
//                 const nextRow = data[startIndex + span];
//                 const nextKey = `${nextRow.clientName}_${nextRow.year}_${nextRow.month}_${nextRow.credits}`;

//                 if (nextKey !== currentKey) {
//                     break;
//                 }

//                 span += 1;
//             }

//             spans[startIndex] = span;
//             startIndex += span;
//         }

//         return spans;
//     };

//     const creditRowSpans = calculateCreditRowSpans(filteredCreditsData);

//     const handleEdit = (row) => {
//         setEditingRow(row);
//         setEditPricing(row.credits.toString());
//         setEditPricingError('');
//         setPriceChangeMessage('');
//         setEditDialogOpen(true);
//     };

//     const handleSaveEdit = () => {
//         setEditPricingError('');

//         let hasError = false;

//         if (!editPricing || parseFloat(editPricing) <= 0) {
//             setEditPricingError('Please enter valid pricing');
//             hasError = true;
//         }

//         if (hasError) return;

//         const updateData = {
//             Id: editingRow.ClientCreditsId,
//             Credits:editPricing //parseInt(editPricing, 10)
//         };

//         updateCredits(updateData, (response) => {
//             if (response.status === 200 || response.status === 201) {
//                 setMessage('Credits updated successfully!');
//                 setAlertType('success');
//                 setStatusBase(true);

//                 getCredits((response) => {
//                     if (response.status === 200) {
//                         const resultData = response.data;
//                         let res = JSON.parse(JSON.stringify(resultData));
//                         const processedData = processCreditsData(res);
//                         const sortedData = sortCreditsRows(processedData);
//                         setCreditsData(sortedData);
//                     }
//                 });

//                 handleCloseEditDialog();
//             } else {
//                 setMessage('Update failed');
//                 setAlertType('error');
//                 setStatusBase(true);
//             }
//         });
//     };

//     const handleCloseEditDialog = () => {
//         setEditDialogOpen(false);
//         setEditingRow(null);
//         setEditPricing('');
//         setPriceChangeMessage('');
//     };

//     const checkExistingCredits = (clientId, year, months, locationName = '') => {
//         const existingCredits = creditsData.filter(row => {
//             const clientMatch = client.find(c => c.ID === clientId);
//             if (!clientMatch) return false;

//             return (
//                 row.clientName === clientMatch.displayname &&
//                 (row.location || '') === (locationName || '') &&
//                 row.year === parseInt(year)
//             );
//         });

//         const existingMonths = [];
//         months.forEach(monthName => {
//             const monthNumber = monthOptions.findIndex(m => m === monthName) + 1;
//             const monthExists = existingCredits.some(row => row.month === monthNumber);

//             if (monthExists) {
//                 existingMonths.push(monthName);
//             }
//         });

//         return existingMonths;
//     };


    

//     return (
//         <Page title="Credits">
//             <Card variant="outlined" sx={{ p: 1 }}>
//                 <CardContent>
//                     <Typography variant="h4">Add Credits</Typography>
//                     <Grid container spacing={2} mt={1}>
//                         {/* Clients Single-Select */}
//                         <Grid item xs={2}>
//                             <FormControl fullWidth error={!!clientError}>
//                                 <InputLabel>Clients</InputLabel>
//                                 <Select
//                                     value={selectedClients[0] || ''}
//                                     onChange={handleClientChange}
//                                     input={<OutlinedInput label="Select Clients" />}
//                                     // renderValue={(selected) => (
//                                     //     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                                     //         {selected.map((client) => (
//                                     //             <Chip 
//                                     //                 key={client.ID || client.id} 
//                                     //                 label={client.displayname} 
//                                     //                 size="small"
//                                     //             />
//                                     //         ))}
//                                     //     </Box>
//                                     // )}
//                                     //renderValue={() => ''}
//                                     MenuProps={{
//                                         PaperProps: {
//                                             style: {
//                                                 maxHeight: 300,
//                                             },
//                                         },
//                                         dense: true,
//                                     }}
//                                 >
//                                     {uniqueClientOptions.map((clientItem) => (
//                                         <MenuItem
//                                             key={clientItem.ID || clientItem.id}
//                                             value={clientItem}
//                                             sx={{ py: 0.2 }}
//                                         >
//                                             <Typography variant="body2" sx={{ fontSize: '16px' }}>
//                                                 {clientItem.displayname}
//                                             </Typography>
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                                 {clientError && <Typography variant="caption" color="error" sx={{ ml: 1.5, mt: 0.5, display: 'block' }}>
//                                     {clientError}
//                                 </Typography>}
//                             </FormControl>
//                         </Grid>

//                         {locations.length > 0 && (
//                             <Grid item xs={2}>
//                                 <Autocomplete
//                                     options={locations}
//                                     value={selectedLocation}
//                                     onChange={handleLocationChange}
//                                     isOptionEqualToValue={(option, value) =>
//                                         Number(option.ID || option.id) === Number(value?.ID || value?.id)
//                                     }
//                                     getOptionLabel={(option) => `${option?.Location || ''}`}
//                                     // renderOption={(props, option) => (
//                                     //     <li {...props} key={option.ID || option.id}>
//                                     //         {option.Location}
//                                     //     </li>
//                                     // )}
//                                     //renderValue={() => ''}
//                                     renderInput={(params) => (
//                                         <TextField
//                                             {...params}
//                                             label="Locations"
//                                             placeholder="Search Locations..."
//                                             error={!!locationError}
//                                             helperText={locationError}
//                                         />
//                                     )}
//                                 />
//                             </Grid>
//                         )}

//                         {/* Years Single-Select */}
//                         <Grid item xs={2}>
//                             <FormControl fullWidth error={!!yearError}>
//                                 <InputLabel>Select Years</InputLabel>
//                                 <Select
//                                     value={selectedYears || ''}
//                                     onChange={handleYearChange}
//                                     input={<OutlinedInput label="Select Years" />}
//                                     // renderValue={(selected) => (
//                                     //     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                                     //         {selected.map((year) => (
//                                     //             <Chip key={year} label={year} size="small" />
//                                     //         ))}
//                                     //     </Box>
//                                     // )}
//                                     //renderValue={() => ''}
//                                     MenuProps={{
//                                         PaperProps: {
//                                             style: {
//                                                 maxHeight: 300,
//                                             },
//                                         },
//                                         dense: true,
//                                     }}
//                                 >
//                                     {yearOptions.map((year) => (
//                                         <MenuItem
//                                             key={year}
//                                             value={year}
//                                             sx={{ py: 0.2 }}
//                                         >
//                                             <Typography variant="body2" sx={{ fontSize: '16px' }}>{year}</Typography>
//                                         </MenuItem>
//                                     ))}
//                                 </Select>
//                                 {yearError && <Typography variant="caption" color="error" sx={{ ml: 1.5, mt: 0.5, display: 'block' }}>
//                                     {yearError}
//                                 </Typography>}
//                             </FormControl>
//                         </Grid>

//                         {/* Months Multi-Select with Checkboxes */}
//                         <Grid item xs={2}>
//                             <FormControl fullWidth error={!!monthsError}>
//                                 <InputLabel>Select Months</InputLabel>
//                                 <Select
//                                     multiple
//                                     value={selectedMonths}
//                                     onChange={handleMonthChange}
//                                     input={<OutlinedInput label="Select Months" />}
//                                     // renderValue={(selected) => (
//                                     //     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                                     //         {selected.map((month) => (
//                                     //             <Chip key={month} label={month} size="small" />
//                                     //         ))}
//                                     //     </Box>
//                                     // )}
//                                     renderValue={() => ''}
//                                     MenuProps={{
//                                         PaperProps: {
//                                             style: {
//                                                 maxHeight: 300,
//                                             },
//                                         },
//                                         dense: true,
//                                     }}
//                                 >
//                                     <MenuItem
//                                         value="select-all"
//                                         sx={{ py: 0.2 }}
//                                     >
//                                         <Checkbox
//                                             checked={selectedMonths.length === monthOptions.length}
//                                             size="small"
//                                         />
//                                         <Typography variant="body2" sx={{ fontSize: '16px' }}>Select All</Typography>
//                                     </MenuItem>

//                                     {monthOptions.map((month, index) => {
//                                         const currentMonthIndex = new Date().getMonth();
//                                         const isCurrentYear = parseInt(selectedYears, 10) === currentYear;
//                                         const isDisabled = isCurrentYear ? index < currentMonthIndex : false;

//                                         return (
//                                             <MenuItem
//                                                 key={month}
//                                                 value={month}
//                                                 disabled={isDisabled}
//                                                 sx={{ py: 0.2 }}
//                                             >
//                                                 <Checkbox
//                                                     checked={selectedMonths.indexOf(month) > -1}
//                                                     disabled={isDisabled}
//                                                     size="small"
//                                                 />
//                                                 <Typography variant="body2" sx={{ fontSize: '16px' }}>{month}</Typography>
//                                             </MenuItem>
//                                         );
//                                     })}
//                                 </Select>
//                                 {monthsError && <Typography variant="caption" color="error" sx={{ ml: 1.5, mt: 0.5, display: 'block' }}>
//                                     {monthsError}
//                                 </Typography>}
//                             </FormControl>
//                         </Grid>

//                         <Grid item xs={2}>
//                             <TextField
//                                 fullWidth
//                                 label="Credits"
//                                 type="number"
//                                 value={pricing}
//                                 onChange={(e) => {
//                                     setPricing(e.target.value);
//                                     setPricingError('');
//                                 }}
//                                 error={!!pricingError}
//                                 helperText={pricingError}
//                                 InputProps={{
//                                     startAdornment: <InputAdornment position="start">$</InputAdornment>,
//                                 }}
//                             />
//                         </Grid>
//                         <Grid item xs={2} mt={1}>
//                             <Stack direction="row" spacing={1}>
//                                 <Button variant="contained" onClick={handleAdd}>
//                                     Add
//                                 </Button>
//                                 <Button variant="contained" color="error" onClick={handleClear}>
//                                     Clear
//                                 </Button>
//                             </Stack>
//                         </Grid>
//                     </Grid>

//                     {(status && message) && (
//                         <Stack direction="row" sx={{ paddingTop: 2 }}>
//                             <Alert
//                                 severity={alertType}
//                                 sx={{
//                                     width: '30%',
//                                     opacity: 0,
//                                     animation: 'fadeInOut 2.5s ease-in-out',
//                                     '@keyframes fadeInOut': {
//                                         '0%': { opacity: 0 },
//                                         '20%': { opacity: 1 },
//                                         '80%': { opacity: 1 },
//                                         '100%': { opacity: 0 },
//                                     }
//                                 }}
//                             >
//                                 {message}
//                             </Alert>
//                         </Stack>
//                     )}

//                     {/* Rest of the table code remains the same */}
//                     <Grid container spacing={3} alignItems="center" sx={{ marginTop: "40px", width: '100%', marginLeft: '0px' }}>
//                         <Scrollbar>
//                             <TableContainer>
//                                 <Table stickyHeader>
//                                     <TableHead sx={{ background: "#f3f3f3" }}>
//                                         <TableRow sx={{ background: '#f3f3f3' }}>
//                                             <TableCell>S.No</TableCell>
//                                             <TableCell>Client Name</TableCell>
//                                             <TableCell>Locations</TableCell>
//                                             <TableCell>Year</TableCell>
//                                             <TableCell>Month</TableCell>
//                                             <TableCell>Credits($)</TableCell>
//                                             <TableCell>Actions</TableCell>
//                                         </TableRow>
//                                     </TableHead>
//                                     <TableBody>
//                                         {filteredCreditsData.map((row, index) => {
//                                             const currentClientKey = row.clientName;
//                                             const previousClientKey = index > 0
//                                                 ? filteredCreditsData[index - 1].clientName
//                                                 : null;
//                                             const currentGroupKey = `${row.clientName}_${row.location || ''}`;
//                                             const previousGroupKey = index > 0
//                                                 ? `${filteredCreditsData[index - 1].clientName}_${filteredCreditsData[index - 1].location || ''}`
//                                                 : null;
//                                             const isFirstRow =
//                                                 index === 0 ||
//                                                 previousClientKey !== currentClientKey;

//                                             const isFirstLocationRow =
//                                                 index === 0 ||
//                                                 previousGroupKey !== currentGroupKey;

//                                             const isFirstYearRow =
//                                                 index === 0 ||
//                                                 previousGroupKey !== currentGroupKey ||
//                                                 filteredCreditsData[index - 1].year !== row.year;
//                                             const previousCreditKey = index > 0
//                                                 ? `${filteredCreditsData[index - 1].clientName}_${filteredCreditsData[index - 1].year}_${filteredCreditsData[index - 1].month}_${filteredCreditsData[index - 1].credits}`
//                                                 : null;
//                                             const currentCreditKey = `${row.clientName}_${row.year}_${row.month}_${row.credits}`;
//                                             const isFirstCreditRow =
//                                                 index === 0 ||
//                                                 previousCreditKey !== currentCreditKey;
//                                             return (
//                                                 <TableRow key={index}>
//                                                     {isFirstRow && (
//                                                         <TableCell rowSpan={rowSpanCounts[currentClientKey]}>
//                                                             {row.id}
//                                                         </TableCell>
//                                                     )}

//                                                     {isFirstRow && (
//                                                         <TableCell rowSpan={rowSpanCounts[currentClientKey]}>
//                                                             {row.clientName}
//                                                         </TableCell>
//                                                     )}

//                                                     {isFirstLocationRow && (
//                                                         <TableCell rowSpan={locationRowSpanCounts[currentGroupKey]}>
//                                                             {row.location || 'N/A'}
//                                                         </TableCell>
//                                                     )}

//                                                     {isFirstYearRow && (
//                                                         <TableCell
//                                                             rowSpan={yearRowSpanCounts[`${row.clientName}_${row.location || ''}_${row.year}`]}
//                                                             sx={{ verticalAlign: "middle" }}
//                                                         >
//                                                             {row.year}
//                                                         </TableCell>
//                                                     )}

//                                                     <TableCell>
//                                                         {monthOptions[(row.month - 1)]}
//                                                     </TableCell>
//                                                     {isFirstCreditRow && (
//                                                         <TableCell rowSpan={creditRowSpans[index]}>
//                                                             {row.credits}
//                                                         </TableCell>
//                                                     )}
//                                                     <TableCell>
//                                                         <Grid container spacing={2}>
//                                                             <Grid item>
//                                                                 <Button
//                                                                     style={{
//                                                                         color: "#fff"
//                                                                     }}
//                                                                     variant="contained"
//                                                                     onClick={() => handleEdit(row)}>
//                                                                     Edit
//                                                                 </Button>
//                                                             </Grid>
//                                                         </Grid>
//                                                     </TableCell>
//                                                 </TableRow>
//                                             );
//                                         })}

//                                         {creditsData.length === 0 && (
//                                             <TableRow>
//                                                 <TableCell colSpan={7} align="center">No Data</TableCell>
//                                             </TableRow>
//                                         )}
//                                     </TableBody>
//                                 </Table>
//                             </TableContainer>
//                         </Scrollbar>
//                     </Grid>
//                 </CardContent>

//                 {/* Edit Dialog remains the same */}
//                 <Dialog
//                     open={editDialogOpen}
//                     onClose={handleCloseEditDialog}
//                     maxWidth="xs"
//                     fullWidth
//                 >
//                     <DialogTitle>
//                         Edit Credits
//                         <IconButton
//                             aria-label="close"
//                             onClick={handleCloseEditDialog}
//                             sx={{
//                                 position: 'absolute',
//                                 right: 8,
//                                 top: 8,
//                                 color: (theme) => theme.palette.grey[500],
//                             }}
//                         >
//                             <CloseIcon />
//                         </IconButton>
//                     </DialogTitle>
//                     <DialogContent dividers>
//                         <Box sx={{ mt: 2 }}>
//                             <Grid container spacing={2}>
//                                 <Grid item xs={12}>
//                                     <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                                         Client: <Typography component="span" sx={{ fontWeight: 'bold' }}>{editingRow?.clientName}</Typography>
//                                     </Typography>
//                                 </Grid>
//                                 <Grid item xs={6}>
//                                     <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                                         Year: <Typography component="span" sx={{ fontWeight: 'bold' }}>{editingRow?.year}</Typography>
//                                     </Typography>
//                                 </Grid>
//                                 <Grid item xs={6}>
//                                     <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                                         Month: <Typography component="span" sx={{ fontWeight: 'bold' }}>{editingRow ? monthOptions[editingRow.month - 1] : ''}</Typography>
//                                     </Typography>
//                                 </Grid>
//                                 <Grid item xs={12}>
//                                     <TextField
//                                         fullWidth
//                                         label="Credits"
//                                         type="number"
//                                         value={editPricing}
//                                         onChange={(e) => {
//                                             const newValue = e.target.value;
//                                             setEditPricing(newValue);
//                                             setEditPricingError('');

//                                             if (editingRow && parseFloat(newValue) === parseFloat(editingRow.credits)) {
//                                                 setPriceChangeMessage('Price is same as current value');
//                                             }
//                                             else {
//                                                 setPriceChangeMessage('');
//                                             }
//                                         }}
//                                         error={!!editPricingError}
//                                         helperText={editPricingError || priceChangeMessage || ' '}
//                                         InputProps={{
//                                             startAdornment: <InputAdornment position="start">$</InputAdornment>,
//                                         }}
//                                         sx={{
//                                             mt: 2,
//                                             '& .MuiFormHelperText-root': {
//                                                 color: priceChangeMessage === 'Price is same as current value' ? 'warning.main' : 'text.secondary'
//                                             }
//                                         }}
//                                         autoFocus
//                                     />
//                                 </Grid>
//                             </Grid>
//                         </Box>
//                     </DialogContent>
//                     <DialogActions sx={{ p: 2 }}>
//                         <Button variant="outlined" color='error' onClick={handleCloseEditDialog}>Cancel</Button>
//                         <Button variant="contained" onClick={handleSaveEdit}>
//                             Update
//                         </Button>
//                     </DialogActions>
//                 </Dialog>
//             </Card>
//         </Page>
//     );
// }



import {
    Container,
    Typography,
    Stack,
    Grid,
    TextField,
    Autocomplete,
    CardContent,
    Card,
    FormControl,
    MenuItem,
    InputLabel,
    OutlinedInput,
    Chip,
    Box, Select,
    InputAdornment,
    Button,
    FormControlLabel,
    Checkbox,
    TableHead,
    TableRow,
    TableCell,
    Table,
    TableContainer,
    TableBody,
    Alert,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    ListSubheader
} from '@mui/material';
import Page from 'src/components/Page';
import clientApi from 'src/api/clients';
import { useEffect, useState } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { addCredits, getCredits, updateCredits } from 'src/api/credits';
import CloseIcon from '@mui/icons-material/Close';
import { getClientProperties } from 'src/api/ShiftMaster';


export default function Credits() {
    const [client, setClient] = useState([]);
    const [selectedClients, setSelectedClients] = useState([]);
    const [inputValue, setInputValue] = useState([]);
    const [status, setStatusBase] = useState(false);
    const [message, setMessage] = useState('');
    const [selectedYears, setSelectedYears] = useState('');
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [pricing, setPricing] = useState('');
    const [remarks, setRemarks] = useState('');
    const [clientError, setClientError] = useState('');
    const [yearError, setYearError] = useState('');
    const [monthsError, setMonthsError] = useState('');
    const [locationError, setLocationError] = useState('');
    const [pricingError, setPricingError] = useState('');
    const [remarksError, setRemarksError] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [creditsData, setCreditsData] = useState([]);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [editPricing, setEditPricing] = useState('');
    const [editRemarks, setEditRemarks] = useState('');
    const [editPricingError, setEditPricingError] = useState('');
    const [editRemarksError, setEditRemarksError] = useState('');
    const [priceChangeMessage, setPriceChangeMessage] = useState('');

    const normalizeDisplayName = (name) =>
        String(name || '')
            .trim()
            .replace(/\s+/g, ' ')
            .toLowerCase();

    const buildUniqueClientOptions = (clients) => {
        const grouped = new Map();

        (clients || []).forEach((clientItem) => {
            const key = normalizeDisplayName(clientItem?.displayname);
            if (!key) return;

            if (!grouped.has(key)) {
                grouped.set(key, []);
            }

            grouped.get(key).push(clientItem);
        });

        return Array.from(grouped.values()).map((groupItems) => {
            if (groupItems.length === 1) {
                return groupItems[0];
            }

            const assignTargets = new Set(
                groupItems
                    .map((item) => Number(item.AssignClient || 0))
                    .filter((assignId) => assignId > 0)
            );

            const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
            if (mappedMain) {
                return mappedMain;
            }

            const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
            return rootEntry || groupItems[0];
        });
    };

     const monthOptions = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const uniqueClientOptions = buildUniqueClientOptions(client);

    const currentYear = new Date().getFullYear();
    const yearOptions = [currentYear, currentYear + 1, currentYear + 2];


    const filteredCreditsData = creditsData.filter((row) => {
    const clientMatch =
        selectedClients.length === 0 ||
        selectedClients.some(
            (c) =>
                c.displayname.trim().toLowerCase() ===
                row.clientName.trim().toLowerCase()
        );

    const yearMatch =
    !selectedYears ||
    row.year === Number(selectedYears);

    const monthMatch =
        selectedMonths.length === 0 ||
        selectedMonths.some(
            (month) =>
                monthOptions.findIndex((m) => m === month) + 1 === row.month
        );

    return clientMatch && yearMatch && monthMatch;
});

   

    useEffect(() => {
        clientApi.getClients((response) => {
            if (response.status === 200) {
                const usClients = response.data.filter(client => client.ClientType === "US" && client.EnvironmentType!==0);
                const sortedData = [...usClients].sort((a, b) =>
                    a.displayname.trim().localeCompare(b.displayname.trim())
                )
                setClient(sortedData)
            }
        })
    }, [])

    const handleClientChange = (event) => {
        const value = event.target.value;
        const selected = value ? [value] : [];

        setSelectedClients(selected);
        if (selected.length > 0) {
            fetchLocationsByClients(selected);
        } else {
            setLocations([]);
            setSelectedLocation(null);
        }
        setClientError('');
    };

    const handleYearChange = (event) => {
        setSelectedYears(event.target.value);
        setYearError('');
    };

    const handleMonthChange = (event) => {
        const value = event.target.value;

        if (value.includes('select-all')) {
            if (selectedMonths.length === monthOptions.length) {
                setSelectedMonths([]);
            } else {
                setSelectedMonths([...monthOptions]);
            }
        } else {
            setSelectedMonths(value.filter(v => v !== 'select-all'));
        }
        setMonthsError('');
    };

    const fetchLocationsByClients = (clients) => {
        if (!clients || clients.length === 0) {
            setLocations([]);
            setSelectedLocation(null);
            return;
        }

        const mainClientId = Number(clients?.[0]?.ID || clients?.[0]?.id || 0);
        if (!mainClientId) {
            setLocations([]);
            setSelectedLocation(null);
            return;
        }

        getClientProperties({ AssignClient: String(mainClientId) }, (response) => {
            if (response.status === 200) {
                const uniqueLocations = Array.from(
                    new Map(normalizeLocations(response.data).map((location) => [location.ID, location])).values()
                );
                setLocations(uniqueLocations);
            } else {
                setLocations([]);
            }
            setSelectedLocation(null);
        });
    };

    const normalizeLocations = (locationResponse) => {
        const responseArray = Array.isArray(locationResponse)
            ? locationResponse
            : (locationResponse ? [locationResponse] : []);

        return responseArray
            .map((location) => ({
                ...location,
                ID: Number(location?.ID ?? location?.id ?? 0),
                Location: (location?.Location || location?.name || '').trim()
            }))
            .filter((location) => location.ID > 0);
    };

    const handleLocationChange = (_, value) => {
        setSelectedLocation(value);
        if (value) {
            setLocationError('');
        }
    };

    useEffect(() => {
        const updatedInputValues = inputValue.filter(camera => selectedClients.includes(camera.clientid));
        setInputValue([...updatedInputValues]);
    }, [selectedClients.length]);

    const processCreditsData = (apiData) => {
        const rows = [];
        let clientCounter = 1;

        apiData.forEach(clientData => {
            const clientName = Object.keys(clientData)[0];
            const creditEntries = clientData[clientName];
            const clientId = clientCounter++;
            const clientLocation = (clientData.Location || '').trim();

            creditEntries.forEach(entry => {
                entry.credit_details.forEach(detail => {
                    rows.push({
                        id: clientId,
                        clientName: clientName,
                        location: clientLocation,
                        year: entry.year,
                        month: detail.Month,
                        credits: detail.Credits,
                        remarks: detail.Remarks || '',
                        ClientCreditsId: detail.ClientCreditsId
                    });
                });
            });
        });

        return rows;
    };

    const sortCreditsRows = (rows) => [...rows].sort((a, b) => {
        if (a.clientName < b.clientName) return -1;
        if (a.clientName > b.clientName) return 1;

        if (a.year !== b.year) return a.year - b.year;

        if (a.month !== b.month) return a.month - b.month;

        if (a.credits !== b.credits) return a.credits - b.credits;

        return (a.location || '').localeCompare(b.location || '');
    });

    useEffect(() => {
        getCredits((response) => {
            if (response.status === 200) {
                const resultData = response.data;
                let res = JSON.parse(JSON.stringify(resultData));
                const processedData = processCreditsData(res);
                const sortedData = sortCreditsRows(processedData);
                setCreditsData(processedData);
            }
        })
    }, [])

    const handleClear = () => {
        setSelectedClients([]);
        setSelectedYears('');
        setSelectedMonths([]);
        setLocations([]);
        setSelectedLocation(null);
        setPricing('');
        setRemarks('');
        setClientError('');
        setYearError('');
        setMonthsError('');
        setLocationError('');
        setPricingError('');
        setRemarksError('');
    };

    const handleAdd = () => {
        setClientError('');
        setYearError('');
        setMonthsError('');
        setLocationError('');
        setPricingError('');
        setRemarksError('');

        let hasError = false;

        if (!selectedClients.length) {
            setClientError('Please select at least one client');
            hasError = true;
        }

       if (!selectedYears) {
            setYearError('Please select at least one year');
            hasError = true;
        }

        if (!selectedMonths.length) {
            setMonthsError('Please select at least one month');
            hasError = true;
        }

        if (locations.length > 0 && !selectedLocation) {
            setLocationError('Please select a location');
            hasError = true;
        }

        if (!pricing || parseFloat(pricing) <= 0) {
            setPricingError('Please enter valid pricing');
            hasError = true;
        }

        // Mandatory remarks validation
        if (!remarks || remarks.trim() === '') {
            setRemarksError('Remarks are required');
            hasError = true;
        }

        if (hasError) return;

        // Check for existing credits for each selected client
        const allExistingMonths = [];
        selectedClients.forEach(clientItem => {
            const clientId = clientItem.ID;
            const clientName = clientItem.displayname;
            const existingMonths = checkExistingCredits(
                clientId,
                selectedYears,
                selectedMonths,
                selectedLocation?.Location || ''
            );

            if (existingMonths.length > 0) {
                allExistingMonths.push({
                    clientName,
                    year: selectedYears,
                    months: existingMonths
                });
            }
        });

        // if (allExistingMonths.length > 0) {
        //     const errorMessages = allExistingMonths.map(item => 
        //         `${item.clientName} (${item.year}) - ${item.months.join(', ')}`
        //     );
        //     setMessage(`Data already exists for:\n${errorMessages.join('\n')}. Please go to edit option to update it.`);
        //     setAlertType('error');
        //     setStatusBase(true);
        //     return;
        // }

        // Prepare data for each client and year combination
        const monthsArray = selectedMonths.map(monthName => {
            const monthIndex = monthOptions.findIndex(m => m === monthName);
            return {
                Month: monthIndex + 1,
                Credits: parseFloat(pricing),
                Remarks: remarks.trim() // Mandatory remarks
            };
        });

        const selectedClientIds = selectedClients
            .map((selectedClient) => String(selectedClient.ID || selectedClient.id || ''))
            .filter((id) => id);
        
        const selectedLocationId = String(selectedLocation?.ID || selectedLocation?.id || '');
        const payloadIds = locations.length > 0 && selectedLocationId && Number(selectedLocationId) > 0
            ? [selectedLocationId]
            : selectedClientIds;

        const requestData = {
            ClientId: payloadIds.join(','),
            Year: selectedYears.toString(),
            months: monthsArray
        };

        addCredits(requestData, (response) => {
            if (response.status === 200 || response.status === 201) {
                setMessage('Credits added successfully!');
                setAlertType('success');
                setStatusBase(true);
                //handleClear();
                setSelectedYears('');
                setSelectedMonths([]);
                setLocations([]);
                setSelectedLocation(null);
                setPricing('');
                setRemarks('');
                setClientError('');
                setYearError('');
                setMonthsError('');
                setLocationError('');
                setPricingError('');
                setRemarksError('');
                getCredits((response) => {
                    if (response.status === 200) {
                        const resultData = response.data;
                        let res = JSON.parse(JSON.stringify(resultData));
                        const processedData = processCreditsData(res);
                        const sortedData = sortCreditsRows(processedData);
                        setCreditsData(sortedData);
                    }
                });
            }
            else {
                setMessage(`Data insertion failed`);
                setAlertType('error');
                setStatusBase(true);
            }
        })
    };

    useEffect(() => {
        if (status && message) {
            const timer = setTimeout(() => {
                setMessage('');
                setStatusBase(false);
            }, 2000);

            return () => clearTimeout(timer);
        }
    }, [status, message]);

    const calculateRowSpan = (data) => {
        const counts = {};

        data.forEach(row => {
            const key = row.clientName;
            counts[key] = (counts[key] || 0) + 1;
        });

        return counts;
    };

    const rowSpanCounts = calculateRowSpan(filteredCreditsData);

    const calculateLocationRowSpan = (data) => {
        const counts = {};

        data.forEach(row => {
            const key = `${row.clientName}_${row.location || ''}`;
            counts[key] = (counts[key] || 0) + 1;
        });

        return counts;
    };

    const locationRowSpanCounts = calculateLocationRowSpan(filteredCreditsData);

    const calculateYearRowSpan = (data) => {
        const map = {};

        data.forEach(row => {
            const key = `${row.clientName}_${row.location || ''}_${row.year}`;
            map[key] = (map[key] || 0) + 1;
        });

        return map;
    };

    const yearRowSpanCounts = calculateYearRowSpan(filteredCreditsData);

    const calculateCreditRowSpans = (data) => {
        const spans = {};
        let startIndex = 0;

        while (startIndex < data.length) {
            const currentRow = data[startIndex];
            const currentKey = `${currentRow.clientName}_${currentRow.year}_${currentRow.month}_${currentRow.credits}`;
            let span = 1;

            while (startIndex + span < data.length) {
                const nextRow = data[startIndex + span];
                const nextKey = `${nextRow.clientName}_${nextRow.year}_${nextRow.month}_${nextRow.credits}`;

                if (nextKey !== currentKey) {
                    break;
                }

                span += 1;
            }

            spans[startIndex] = span;
            startIndex += span;
        }

        return spans;
    };

    const creditRowSpans = calculateCreditRowSpans(filteredCreditsData);

    const handleEdit = (row) => {
        setEditingRow(row);
        setEditPricing(row.credits.toString());
        setEditRemarks(row.remarks || '');
        setEditPricingError('');
        setEditRemarksError('');
        setPriceChangeMessage('');
        setEditDialogOpen(true);
    };

    const handleSaveEdit = () => {
        setEditPricingError('');
        setEditRemarksError('');

        let hasError = false;

        if (!editPricing || parseFloat(editPricing) <= 0) {
            setEditPricingError('Please enter valid pricing');
            hasError = true;
        }

        // Mandatory remarks validation for edit
        if (!editRemarks || editRemarks.trim() === '') {
            setEditRemarksError('Remarks are required');
            hasError = true;
        }

        if (hasError) return;

        const updateData = {
            Id: editingRow.ClientCreditsId,
            Credits: editPricing,
            Remarks: editRemarks.trim() // Mandatory remarks
        };

        updateCredits(updateData, (response) => {
            if (response.status === 200 || response.status === 201) {
                setMessage('Credits updated successfully!');
                setAlertType('success');
                setStatusBase(true);

                getCredits((response) => {
                    if (response.status === 200) {
                        const resultData = response.data;
                        let res = JSON.parse(JSON.stringify(resultData));
                        const processedData = processCreditsData(res);
                        const sortedData = sortCreditsRows(processedData);
                        setCreditsData(sortedData);
                    }
                });

                handleCloseEditDialog();
            } else {
                setMessage('Update failed');
                setAlertType('error');
                setStatusBase(true);
            }
        });
    };

    const handleCloseEditDialog = () => {
        setEditDialogOpen(false);
        setEditingRow(null);
        setEditPricing('');
        setEditRemarks('');
        setPriceChangeMessage('');
    };

    const checkExistingCredits = (clientId, year, months, locationName = '') => {
        const existingCredits = creditsData.filter(row => {
            const clientMatch = client.find(c => c.ID === clientId);
            if (!clientMatch) return false;

            return (
                row.clientName === clientMatch.displayname &&
                (row.location || '') === (locationName || '') &&
                row.year === parseInt(year)
            );
        });

        const existingMonths = [];
        months.forEach(monthName => {
            const monthNumber = monthOptions.findIndex(m => m === monthName) + 1;
            const monthExists = existingCredits.some(row => row.month === monthNumber);

            if (monthExists) {
                existingMonths.push(monthName);
            }
        });

        return existingMonths;
    };


    

    return (
        <Page title="Credits">
            <Card variant="outlined" sx={{ p: 1 }}>
                <CardContent>
                    <Typography variant="h4">Add Credits</Typography>
                    <Grid container spacing={2} mt={1}>
                       
                        <Grid item xs={2}>
                            <Autocomplete
                                options={uniqueClientOptions}
                                value={selectedClients[0] || null}
                                onChange={(event, newValue) => {
                                    const selected = newValue ? [newValue] : [];
                                    setSelectedClients(selected);
                                    if (selected.length > 0) {
                                        fetchLocationsByClients(selected);
                                    } else {
                                        setLocations([]);
                                        setSelectedLocation(null);
                                    }
                                    setClientError('');
                                }}
                                isOptionEqualToValue={(option, value) => 
                                    option?.ID === value?.ID || option?.id === value?.id
                                }
                                getOptionLabel={(option) => option?.displayname || ''}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Clients"
                                        placeholder="Search Clients..."
                                        error={!!clientError}
                                        helperText={clientError}
                                        
                                    />
                                )}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.ID || option.id}>
                                        <Typography variant="body2" sx={{ fontSize: '16px' }}>
                                            {option.displayname}
                                        </Typography>
                                    </li>
                                )}
                                noOptionsText="No clients found"
                                loadingText="Loading clients..."
                                disableClearable={false}
                                clearOnEscape
                                freeSolo={false}
                                autoHighlight
                            />
                        </Grid>

                        {locations.length > 0 && (
                            <Grid item xs={2}>
                                <Autocomplete
                                    options={locations}
                                    value={selectedLocation}
                                    onChange={handleLocationChange}
                                    isOptionEqualToValue={(option, value) =>
                                        Number(option.ID || option.id) === Number(value?.ID || value?.id)
                                    }
                                    getOptionLabel={(option) => `${option?.Location || ''}`}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Locations"
                                            placeholder="Search Locations..."
                                            error={!!locationError}
                                            helperText={locationError}
                                        />
                                    )}
                                />
                            </Grid>
                        )}

                        {/* Years Single-Select */}
                        <Grid item xs={1}>
                            <FormControl fullWidth error={!!yearError}>
                                <InputLabel>Years</InputLabel>
                                <Select
                                    value={selectedYears || ''}
                                    onChange={handleYearChange}
                                    input={<OutlinedInput label="Select Years" />}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                        dense: true,
                                    }}
                                >
                                    {yearOptions.map((year) => (
                                        <MenuItem
                                            key={year}
                                            value={year}
                                            sx={{ py: 0.2 }}
                                        >
                                            <Typography variant="body2" sx={{ fontSize: '16px' }}>{year}</Typography>
                                        </MenuItem>
                                    ))}
                                </Select>
                                {yearError && <Typography variant="caption" color="error" sx={{ ml: 1.5, mt: 0.5, display: 'block' }}>
                                    {yearError}
                                </Typography>}
                            </FormControl>
                        </Grid>

                        {/* Months Multi-Select with Checkboxes */}
                        <Grid item xs={2}>
                            <FormControl fullWidth error={!!monthsError}>
                                <InputLabel>Months</InputLabel>
                                <Select
                                    multiple
                                    value={selectedMonths}
                                    onChange={handleMonthChange}
                                    input={<OutlinedInput label="Select Months" />}
                                    renderValue={() => ''}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                        dense: true,
                                    }}
                                >
                                    <MenuItem
                                        value="select-all"
                                        sx={{ py: 0.2 }}
                                    >
                                        <Checkbox
                                            checked={selectedMonths.length === monthOptions.length}
                                            size="small"
                                        />
                                        <Typography variant="body2" sx={{ fontSize: '16px' }}>Select All</Typography>
                                    </MenuItem>

                                    {monthOptions.map((month, index) => {
                                        const currentMonthIndex = new Date().getMonth();
                                        const isCurrentYear = parseInt(selectedYears, 10) === currentYear;
                                        const isDisabled = isCurrentYear ? index < currentMonthIndex : false;

                                        return (
                                            <MenuItem
                                                key={month}
                                                value={month}
                                                disabled={isDisabled}
                                                sx={{ py: 0.2 }}
                                            >
                                                <Checkbox
                                                    checked={selectedMonths.indexOf(month) > -1}
                                                    disabled={isDisabled}
                                                    size="small"
                                                />
                                                <Typography variant="body2" sx={{ fontSize: '16px' }}>{month}</Typography>
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                                {monthsError && <Typography variant="caption" color="error" sx={{ ml: 1.5, mt: 0.5, display: 'block' }}>
                                    {monthsError}
                                </Typography>}
                            </FormControl>
                        </Grid>

                         {/* Remarks Field - Mandatory */}
                        <Grid item xs={2}>
                            <TextField
                                fullWidth
                                label="Remarks"
                                multiline
                                rows={1}
                                value={remarks}
                                onChange={(e) => {
                                    setRemarks(e.target.value);
                                    setRemarksError('');
                                }}
                                error={!!remarksError}
                                helperText={remarksError}
                                placeholder="Enter remarks..."
                                
                            />
                        </Grid>


                        <Grid item xs={1}>
                            <TextField
                                fullWidth
                                label="Credits"
                                type="number"
                                value={pricing}
                                onChange={(e) => {
                                    setPricing(e.target.value);
                                    setPricingError('');
                                }}
                                error={!!pricingError}
                                helperText={pricingError}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                }}
                            />
                        </Grid>

                       
                        <Grid item xs={2} mt={1}>
                            <Stack direction="row" spacing={1}>
                                <Button variant="contained" onClick={handleAdd}>
                                    Add
                                </Button>
                                <Button variant="contained" color="error" onClick={handleClear}>
                                    Clear
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>

                    {(status && message) && (
                        <Stack direction="row" sx={{ paddingTop: 2 }}>
                            <Alert
                                severity={alertType}
                                sx={{
                                    width: '30%',
                                    opacity: 0,
                                    animation: 'fadeInOut 2.5s ease-in-out',
                                    '@keyframes fadeInOut': {
                                        '0%': { opacity: 0 },
                                        '20%': { opacity: 1 },
                                        '80%': { opacity: 1 },
                                        '100%': { opacity: 0 },
                                    }
                                }}
                            >
                                {message}
                            </Alert>
                        </Stack>
                    )}

                    {/* Table with Remarks Column */}
                    <Grid container spacing={3} alignItems="center" sx={{ marginTop: "40px", width: '100%', marginLeft: '0px' }}>
                        <Scrollbar>
                            <TableContainer>
                                <Table stickyHeader>
                                    <TableHead sx={{ background: "#f3f3f3" }}>
                                        <TableRow sx={{ background: '#f3f3f3' }}>
                                            <TableCell>S.No</TableCell>
                                            <TableCell>Client Name</TableCell>
                                            <TableCell>Locations</TableCell>
                                            <TableCell>Year</TableCell>
                                            <TableCell>Month</TableCell>
                                            <TableCell>Credits($)</TableCell>
                                            <TableCell>Remarks</TableCell>
                                            <TableCell>Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredCreditsData.map((row, index) => {
                                            const currentClientKey = row.clientName;
                                            const previousClientKey = index > 0
                                                ? filteredCreditsData[index - 1].clientName
                                                : null;
                                            const currentGroupKey = `${row.clientName}_${row.location || ''}`;
                                            const previousGroupKey = index > 0
                                                ? `${filteredCreditsData[index - 1].clientName}_${filteredCreditsData[index - 1].location || ''}`
                                                : null;
                                            const isFirstRow =
                                                index === 0 ||
                                                previousClientKey !== currentClientKey;

                                            const isFirstLocationRow =
                                                index === 0 ||
                                                previousGroupKey !== currentGroupKey;

                                            const isFirstYearRow =
                                                index === 0 ||
                                                previousGroupKey !== currentGroupKey ||
                                                filteredCreditsData[index - 1].year !== row.year;
                                            const previousCreditKey = index > 0
                                                ? `${filteredCreditsData[index - 1].clientName}_${filteredCreditsData[index - 1].year}_${filteredCreditsData[index - 1].month}_${filteredCreditsData[index - 1].credits}`
                                                : null;
                                            const currentCreditKey = `${row.clientName}_${row.year}_${row.month}_${row.credits}`;
                                            const isFirstCreditRow =
                                                index === 0 ||
                                                previousCreditKey !== currentCreditKey;
                                            return (
                                                <TableRow key={index}>
                                                    {isFirstRow && (
                                                        <TableCell rowSpan={rowSpanCounts[currentClientKey]}>
                                                            {row.id}
                                                        </TableCell>
                                                    )}

                                                    {isFirstRow && (
                                                        <TableCell rowSpan={rowSpanCounts[currentClientKey]}>
                                                            {row.clientName}
                                                        </TableCell>
                                                    )}

                                                    {isFirstLocationRow && (
                                                        <TableCell rowSpan={locationRowSpanCounts[currentGroupKey]}>
                                                            {row.location || 'N/A'}
                                                        </TableCell>
                                                    )}

                                                    {isFirstYearRow && (
                                                        <TableCell
                                                            rowSpan={yearRowSpanCounts[`${row.clientName}_${row.location || ''}_${row.year}`]}
                                                            sx={{ verticalAlign: "middle" }}
                                                        >
                                                            {row.year}
                                                        </TableCell>
                                                    )}

                                                    <TableCell>
                                                        {monthOptions[(row.month - 1)]}
                                                    </TableCell>
                                                    {isFirstCreditRow && (
                                                        <TableCell rowSpan={creditRowSpans[index]}>
                                                            {row.credits}
                                                        </TableCell>
                                                    )}
                                                    <TableCell>
                                                        {row.remarks || '-'}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Grid container spacing={2}>
                                                            <Grid item>
                                                                <Button
                                                                    style={{
                                                                        color: "#fff"
                                                                    }}
                                                                    variant="contained"
                                                                    onClick={() => handleEdit(row)}>
                                                                    Edit
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}

                                        {creditsData.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={8} align="center">No Data</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Scrollbar>
                    </Grid>
                </CardContent>

                {/* Edit Dialog with Remarks - Mandatory */}
                <Dialog
                    open={editDialogOpen}
                    onClose={handleCloseEditDialog}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle>
                        Edit Credits
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseEditDialog}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Box sx={{ mt: 2 }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                        Client: <Typography component="span" sx={{ fontWeight: 'bold' }}>{editingRow?.clientName}</Typography>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                        Year: <Typography component="span" sx={{ fontWeight: 'bold' }}>{editingRow?.year}</Typography>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                        Month: <Typography component="span" sx={{ fontWeight: 'bold' }}>{editingRow ? monthOptions[editingRow.month - 1] : ''}</Typography>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Credits"
                                        type="number"
                                        value={editPricing}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setEditPricing(newValue);
                                            setEditPricingError('');

                                            if (editingRow && parseFloat(newValue) === parseFloat(editingRow.credits)) {
                                                setPriceChangeMessage('Price is same as current value');
                                            }
                                            else {
                                                setPriceChangeMessage('');
                                            }
                                        }}
                                        error={!!editPricingError}
                                        helperText={editPricingError || priceChangeMessage || ' '}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                        }}
                                        sx={{
                                            mt: 2,
                                            '& .MuiFormHelperText-root': {
                                                color: priceChangeMessage === 'Price is same as current value' ? 'warning.main' : 'text.secondary'
                                            }
                                        }}
                                        autoFocus
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Remarks"
                                        multiline
                                        rows={3}
                                        value={editRemarks}
                                        onChange={(e) => {
                                            setEditRemarks(e.target.value);
                                            setEditRemarksError('');
                                        }}
                                        error={!!editRemarksError}
                                        helperText={editRemarksError}
                                        placeholder="Enter remarks..."
                                        
                                        sx={{ mt: 1 }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button variant="outlined" color='error' onClick={handleCloseEditDialog}>Cancel</Button>
                        <Button variant="contained" onClick={handleSaveEdit}>
                            Update
                        </Button>
                    </DialogActions>
                </Dialog>
            </Card>
        </Page>
    );
}